module.exports = __webpack_public_path__ + "assets/cc56ac93ee56f38f9893ae844ca692fa.png";